import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, Auth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB-7YCd8Pw8KMu2VAhNBkfQqqCsUToK_Zo",
  authDomain: "base-earn.firebaseapp.com",
  projectId: "base-earn",
  storageBucket: "base-earn.appspot.com",
  messagingSenderId: "757912752070",
  appId: "1:757912752070:web:7b2d119b1d8e500a956cc7",
  measurementId: "G-V6P1BS2GK9"
};

// Initialize Firebase
let app;
let analytics;
let auth: Auth;

try {
  app = initializeApp(firebaseConfig);
  analytics = getAnalytics(app);
  auth = getAuth(app);
  
  // Log successful initialization
  console.log('Firebase initialized successfully');
} catch (error) {
  console.error('Error initializing Firebase:', error);
  throw error;
}

export { app, analytics, auth }; 